import { CONFIG } from "~/config";

// test base dlazdice
const TEST_TILE = "base-m/8-138-86";
// timeout na celkove nacteni
const TIMEOUT = 333;

export function checkTileLoad(): Promise<boolean> {
	return new Promise(resolve => {
		if (CONFIG.mapserver.useTileCache) {
			const image = new Image();
			let toId = setTimeout(() => {
				toId = null;
				/* eslint-disable-next-line */
				console.log(`test image timeout error -> fallback`);
				resolve(false);
			}, TIMEOUT);

			image.crossOrigin = CONFIG.mapserver.crossOrigin;
			image.addEventListener("load", () => {
				toId && clearTimeout(toId);
				resolve(true);
			});
			image.addEventListener("error", () => {
				toId && clearTimeout(toId);
				/* eslint-disable-next-line */
				console.log(`test image error -> fallback`);
				resolve(false);
			});
			image.src = `${CONFIG.mapserver.url}/${TEST_TILE}`;
		} else {
			// preskocime pro mapserver
			resolve(true);
		}
	});
}
